'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('buffer'),
    Buffer = _require.Buffer;

var CID = require('cids');

var ndjson = require('iterable-ndjson');

var toIterable = require('stream-to-it/source');

var configure = require('./lib/configure');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _ls = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, options) {
      var searchParams, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, result, _iterator2, _step2, link, entry;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              searchParams = new URLSearchParams();
              searchParams.set('arg', "".concat(Buffer.isBuffer(path) ? new CID(path) : path));
              searchParams.set('stream', options.stream == null ? true : options.stream);
              if (options.long != null) searchParams.set('long', options.long);
              if (options.unsorted != null) searchParams.set('unsorted', options.unsorted);
              if (options.recursive != null) searchParams.set('recursive', options.recursive);
              _context.next = 9;
              return _awaitAsyncGenerator(ky.post('ls', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: searchParams
              }));

            case 9:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 12;
              _iterator = _asyncIterator(ndjson(toIterable(res.body)));

            case 14:
              _context.next = 16;
              return _awaitAsyncGenerator(_iterator.next());

            case 16:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 20;
              return _awaitAsyncGenerator(_step.value);

            case 20:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 55;
                break;
              }

              result = _value;
              result = result.Objects;

              if (result) {
                _context.next = 26;
                break;
              }

              throw new Error('expected .Objects in results');

            case 26:
              result = result[0];

              if (result) {
                _context.next = 29;
                break;
              }

              throw new Error('expected one array in results.Objects');

            case 29:
              result = result.Links;

              if (Array.isArray(result)) {
                _context.next = 32;
                break;
              }

              throw new Error('expected one array in results.Objects[0].Links');

            case 32:
              _iterator2 = _createForOfIteratorHelper(result);
              _context.prev = 33;

              _iterator2.s();

            case 35:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 44;
                break;
              }

              link = _step2.value;
              entry = {
                name: link.Name,
                path: path + '/' + link.Name,
                size: link.Size,
                cid: new CID(link.Hash),
                type: typeOf(link),
                depth: link.Depth || 1
              };

              if (link.Mode) {
                entry.mode = parseInt(link.Mode, 8);
              }

              if (link.Mtime !== undefined && link.Mtime !== null) {
                entry.mtime = {
                  secs: link.Mtime
                };

                if (link.MtimeNsecs !== undefined && link.MtimeNsecs !== null) {
                  entry.mtime.nsecs = link.MtimeNsecs;
                }
              }

              _context.next = 42;
              return entry;

            case 42:
              _context.next = 35;
              break;

            case 44:
              _context.next = 49;
              break;

            case 46:
              _context.prev = 46;
              _context.t0 = _context["catch"](33);

              _iterator2.e(_context.t0);

            case 49:
              _context.prev = 49;

              _iterator2.f();

              return _context.finish(49);

            case 52:
              _iteratorNormalCompletion = true;
              _context.next = 14;
              break;

            case 55:
              _context.next = 61;
              break;

            case 57:
              _context.prev = 57;
              _context.t1 = _context["catch"](12);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 61:
              _context.prev = 61;
              _context.prev = 62;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 66;
                break;
              }

              _context.next = 66;
              return _awaitAsyncGenerator(_iterator.return());

            case 66:
              _context.prev = 66;

              if (!_didIteratorError) {
                _context.next = 69;
                break;
              }

              throw _iteratorError;

            case 69:
              return _context.finish(66);

            case 70:
              return _context.finish(61);

            case 71:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[12, 57, 61, 71], [33, 46, 49, 52], [62,, 66, 70]]);
    }));

    function ls(_x, _x2) {
      return _ls.apply(this, arguments);
    }

    return ls;
  }();
});

function typeOf(link) {
  switch (link.Type) {
    case 1:
    case 5:
      return 'dir';

    case 2:
      return 'file';

    default:
      return 'unknown';
  }
}